import React, {Component} from 'react'
import TiresDashboardView from "./TiresDashboardView";




class TiresDashboard extends Component {


    render() {
        return (
            <TiresDashboardView/>
        )
    }
}



export default (TiresDashboard);